/* Order Form */
// Copied and modified from: static_src/js/c2Archive/orderForm.jsß
(function (__module__, c2) {
  'use strict';


  // Declared here so they're available to several functions; set in applyRequestParams.
  var filterGroup;
  var filterEnv;
  var groupSelectize;
  var resourceNameField;
  var availableGroups;
  var availableGroupIDs;
  // Set in init() by the caller
  var formSetBaseURL;
  var siCostURL;
  var logger = c2.logging.getLogger(__module__);
  var cachedInitialEnvForms;
  var maxNumberOfEnvsToCompare = 10;
  var activeEnv = {};
  var showCostPreview;
  var determineRecipientsEndpoint;
  var staticFileUrlPrefix;
  var hiddenClassName = 'visually-hidden';
  var cuiMode;

  /**
   * Initialize the order view.
   *   formsetURL: the base URL used to load the formset
   *   siFormCostURL: URL for getting the cost of a SI form (and other info to be updated as
   *       values are changed such as hostname preview for PSSI forms).
   *   showCostPreviewSetting: boolean True if cost preview per environment is enabled.
   *   determineRecipientsURL: optional URL for determining recipient options. If falsy, 'ajax_recipient_options'
   *       will be appended to formsetURL. Used by the edit_blueprint_order.html template since it passes a formsetURL
   *       that isn't compatible with such approach.
   */
  function init(formsetURL,
    siFormCostURL,
    showCostPreviewSetting,
    determineRecipientsURL,
    staticUrl) {

    formSetBaseURL = formsetURL;
    siCostURL = siFormCostURL;
    cachedInitialEnvForms = {};
    showCostPreview = showCostPreviewSetting || false;
    determineRecipientsEndpoint = determineRecipientsURL;
    staticFileUrlPrefix = staticUrl;
    cuiMode = getUIMode() === "cui";

    if ($('#id_recipients').length)
      $('#id_recipients').tokenfield('setTokens', 'self');

    $(function () {
      groupSelectize = c2.selectize('select[name=order_group]', {
        onChange: function (groupId) {
          loadBlueprintFormset(groupId);
        }
      });

      availableGroups = groupSelectize.options;
      availableGroupIDs = _.map(availableGroups, 'value');

      // After a user clicks off the `resourceName` field, update the SI Cost
      // on all ServiceItems.
      resourceNameField = $('input[name=resource_name]');
      resourceNameField.on('blur', applyFormsetBehaviors)

      // If bulk ordering is enabled and there's a "recipients" field
      if ($('#id_recipients').length) {
        $('#id_recipients')
          .on('tokenfield:createtoken', function (e) {
            var curr_tokens = $(this).tokenfield('getTokens');
            // look thru the current tokens for one that matches this new one
            var dupes = curr_tokens.filter(function (el) {
              return el.value === e.attrs.value;
            });
            // if we find a match, cancel the creation of this token
            if (dupes.length > 0) e.preventDefault();
          })
          .on('tokenfield:removetoken', function (e) {
            // we're going to prevent the removal of the "self" token
            // if it's the only token in the field.
            var curr_tokens = $(this).tokenfield('getTokens');
            if (e.attrs.label.toUpperCase() === 'SELF' && curr_tokens.length === 1)
              return false;
          })
          .on('tokenfield:removedtoken', function (e) {
            // if all tokens are removed, let's re-add "self"
            var field = $(this)
            var curr_tokens = field.tokenfield('getTokens');
            if (curr_tokens.length === 0) field.tokenfield('setTokens', 'self');
            if (getValidTokens($(this)).length == 0) {
              field.tokenfield('setTokens', 'self');
            }
          })
          .on('tokenfield:createdtoken', function (e) {
            // we have a new token, so let's check with cloudbolt to see if
            // it resolves to a valid user according to cloudbolt's default
            // logic or logic provided by an orchestration action.
            var url = formSetBaseURL + 'ajax_validate_recipient?';
            url += 'group_id=' + $('#id_order_group')[0].value;
            url += '&qry=' + e.attrs.value;
            var $t = $(e.relatedTarget);
            $.ajax({
              url: url, success: function (result) {
                if (!result.length) $t.addClass('invalid');
                else {
                  // for the time being, we're going to only work with the
                  // first result returned.
                  $t.value = result[0].value;
                }
              }
            });
          })
          .on('tokenfield:edittoken', function (e) {
            if (e.attrs.label.toUpperCase() === 'SELF')
              return false;
          });
        $('#id_recipients-tokenfield').blur(function (e) {
          updateFormState();
        });
      }

      $('#blueprint-order-form').submit(handleOrderSubmit);
      $('#blueprint-order-form').on('change', '.form-control, .form-check input[type=radio]', updateFormIfFieldChanged);
      $('#blueprint-order-form').on('keyup', '.form-control, .form-check input[type=radio]', updateFormIfFieldChanged);

      applyRequestParams(availableGroupIDs);

      // Load service item forms for the initial group
      if (availableGroupIDs.length > 0) {
        var groupId = groupSelectize.getValue();
        loadBlueprintFormset(groupId, true);
      } else {
        // there are no groups!
        disableOrderForm(gettext("None of the groups you can submit orders for can deploy this blueprint."));
      }

      // Set up a dynamic tooltip based on the submit button's state
      $('#submit-btn-tip').tooltip({
        // Work around a layout bug where left side of tooltip is hidden
        placement: 'right',
        title: function () {
          if ($('#submit-btn').prop('disabled')) {
            return gettext("Form requires attention");
          }
        }
      });

      // Ensure initial form is shown
      tuneLayoutForFormset();
    });
  }

  function getInvalidTokens(aTokenField) {
    return aTokenField.parent().find('.token.invalid');
  }

  function getValidTokens(aTokenField) {
    return aTokenField.parent().find('.token:not(.invalid)');
  }

  /*
   * Make any server-side validation errors on the ServiceBlueprintOrderForm visible by moving them
   * from the hidden ajax-response area to the actual form field.  If the order form were part of
   * the formset we might not have to do this.
   */
  function showOrderFormValidationErrors() {
    var $errorDiv;
    var $target;
    var className = '.form-group';
    if (cuiMode) {
      className = '.input-group';
    }

    $('.order-form-valid-fields').each(function () {
      $target = $('[name=' + $(this).data('field-name') + ']').closest(className);
      $target.removeClass('has-error').find('ul.errorlist').remove();
    });

    $('.order-form-error-fields').each(function () {
      $errorDiv = $(this);
      $target = $('[name=' + $errorDiv.data('field-name') + ']').closest(className);
      $target.addClass('has-error').append($errorDiv.html()).show();
    });
  }

  function getUIMode() {
    let mode = 'default'
    if ($('#id_ui_mode').length && $('#id_ui_mode')[0].value) {
      mode = $('#id_ui_mode')[0].value
    }
    return mode
  }

  function getUIModeQueryParam() {
    const mode = getUIMode()
    return mode === 'cui' ? 'ui_mode=cui' : ''
  }

  function getRecipientQueryParam() {
    if ($('#id_recipient').length && $('#id_recipient')[0].value) {
      return '&recipient_id=' + $('#id_recipient')[0].value;
    }
    else if ($('#id_recipients').length && $('#id_recipients')[0].value) {
      return '&recipient_ids=' + $('#id_recipients')[0].value;
    } else {
      return '';
    }
  }

  /**
    * Load the blueprint formset for specified `groupId`.
    * Called on initial page load and when changing the group or recipient.
    * `initialPageLoad` and `recipientWasChanged` are boolean flags to
    * specify the context in which the function is being called.
    */
  function loadBlueprintFormset(groupId, initialPageLoad, recipientWasChanged) {
    // Determine which type of recipient form field was included by the template (recipient, recipients (plural), or neither)
    var recipientFieldType;
    if ($('#id_recipients').length) {
      recipientFieldType = 'recipients';
      var $recipientSelect = $('#id_recipients');
      var $recipientFormGroup = $recipientSelect.parent().parent().parent();
    }
    else if ($('#id_recipient').length) {
      recipientFieldType = 'recipient';
      var $recipientSelect = $('#id_recipient');
      var $recipientFormGroup = $recipientSelect.parent().parent();
    }

    // If either type of recipient/s field exists, hide it.
    // If the existent field is the recipients (plural) field, it will be re-shown if a group is selected.
    // If it's the recipient field, it will only be re-shown if a group is selected and the ajax request to determine
    // recipient options actually returns any.
    if (recipientFieldType) {
      $recipientFormGroup.hide();
    }
    if (!groupId) {
      $('#service-items > .tab-content').html('<i>' + gettext("Select a group first") + '</i>');
      // Call this in order to show the formset content
      tuneLayoutForFormset();
      return;
    }

    // If a request is already in process, do not start a new one
    if ($('#blueprint-order-form').find('> .blocker').hasClass('in')) {
      return;
    }

    if (recipientFieldType === 'recipient') {
      var recipientURL;
      if (determineRecipientsEndpoint) {
        recipientURL = determineRecipientsEndpoint;
      } else {
        recipientURL = formSetBaseURL + 'ajax_recipient_options';
      }
      recipientURL += '?group_id=' + groupId;
      var $recipientSelectize = $recipientSelect[0].selectize;
      $.ajax({
        url: recipientURL,
        success: function (data) {
          // Clear the current recipient options if the group field was changed.
          if (!initialPageLoad && !recipientWasChanged) {
            // Set a flag attribute on the element to signal that the onchange handler
            // should not fire when the options are cleared.
            $recipientSelect.attr('data-ignore-change', true);
            $recipientSelectize.clearOptions();
            $recipientSelect.removeAttr('data-ignore-change');
          }
          $recipientSelectize.addOption(data);
          // Only make the recipient visible if there are options, because if there are
          // none we assume that means the requester doesn't have permission for the field
          if ((_.keys($recipientSelectize.options)).length > 0) {
            $recipientFormGroup.show();
          }
        }
      });
    }
    else if (recipientFieldType === 'recipients') {
      $recipientFormGroup.show();
    }

    $('#id_recipient')
      .off('change')
      .on('change', function () {
        if ($(this).attr('data-ignore-change')) {
          return;
        }
        groupSelectize = c2.selectize('select[name=order_group]');
        var groupID = groupSelectize.getValue();
        cachedInitialEnvForms = {};
        loadBlueprintFormset(groupID, false, true);
      });

    $('#cost-preview-wrap').remove();
    var url = formSetBaseURL + '?group_id=' + groupId + getRecipientQueryParam();
    var $target = $('#service-items').html('');

    var onSuccess = function () {
      preloadPSSIFormsForConfiguredEnvs();
      applyFormsetBehaviors();
      applyPostLoadBehaviors();
    };
    var onError = function () {
      // Unhide div so error message can be seen
      tuneLayoutForFormset();
    };
    get_and_load_remote_html(url, $target, onSuccess, onError);
  }


  /**
    * Load the form for a specific PSSI and environment.
    * Called when environment dropdown changes.
    *
    * If a form has already been loaded before, and thus cached, it is shown immediately.
    * Otherwise, the form is loaded and shown as soon as that completes.
    */
  function loadSingleItemForm(groupID, itemID, envID) {
    var $item = $('#item-' + itemID);
    var $target = $item.find(".update-on-env-change");
    var finalizePSSIForm = function () {
      // When we get a single form, it's part of a one-form formset, so it has
      // the prefix "form-0-" even if it's not the first blueprint item.
      // Here we rewrite the prefix with the correct number.
      resequenceForms();
      applySingleItemBehaviors($item);
      applyPostLoadBehaviors();
    };
    var formHTML = getCachedInitialEnvForms(itemID, groupID, envID);

    if (formHTML === undefined) {
      // id_recipient is an array object.
      if ($('#id_recipient').length >= 1) {
        var recipientID = $('#id_recipient')[0].value;
      }
      else {
        var recipientID = ''
      }
      var url = formSetBaseURL + '?group_id=' + groupID + '&service_item=' + itemID + '&env_id=' + envID + getRecipientQueryParam();
      get_and_load_remote_html(url, $target, function (content) {
        finalizePSSIForm();
        cacheInitialEnvForm(itemID, groupID, envID, content);
      });
    } else {
      $target.html(formHTML);
      finalizePSSIForm();
    }
  }


  /**
    * Get HTML from the specified URL and overwrite the target's content.
    * onSuccess is an optional callback to run on success.
    */
  function get_and_load_remote_html(url, $target, onSuccess, onError) {

    c2.spinners.showSpinner({fade: true});

    $.get(url, function (response) {
      if (response.error) {
        // Use html() instead of text() here because we assume that any XSS
        // payloads in the error are escaped server side.
        // This currently happens in the json_view decorator.
        var basePath = new URL(document.baseURI).pathname;
        var url = basePath + 'exception/'
        var msg = $('<div class="alert alert-danger"></div>')
        var link = $('<a href="' + url + '">Click here</a>');
        if (response.traceback) {
            link.on('click', function () {
                var fullErrorMsg = response.error + response.traceback;
                localStorage.setItem('errorMessage', fullErrorMsg);
            });
        } else {
            link.on('click', function () {
                localStorage.setItem('errorMessage', response.error);
            });
        }
        msg.append('Error occured: ').append(link).append(' to see detailed error');
        $target.html(msg);
        if (onError) {
          onError();
        }
      } else {
        $target.html(response.content);
        if (onSuccess) {
          onSuccess(response.content);
        }
      }
      c2.spinners.hideSpinner({fade: true});
    });
  }


  /*
   * Store HTML in a lookup table for subsequent use to show cost comparison.
   *
   * This HTML is not updated as the user makes changes; it is purely for comparing initial costs
   * based on context's initial PSSI form values.
   *
   * Not storing in the DOM because that is much slower and unwieldy to work with.
   */
  function cacheInitialEnvForm(itemID, groupID, envID, formHTML) {
    if (cachedInitialEnvForms[itemID] === undefined) {
      cachedInitialEnvForms[itemID] = {};
    }
    if (cachedInitialEnvForms[itemID][groupID] === undefined) {
      cachedInitialEnvForms[itemID][groupID] = {};
    }

    cachedInitialEnvForms[itemID][groupID][envID] = formHTML;
  }


  /*
   * Return HTML for the initial PSSI form given its ID, and a group and env ID.
   * Return undefined if nothing has been cached.
   */
  function getCachedInitialEnvForms(itemID, groupID, envID) {
    if (cachedInitialEnvForms[itemID] === undefined) {
      cachedInitialEnvForms[itemID] = {};
    }
    if (cachedInitialEnvForms[itemID][groupID] === undefined) {
      cachedInitialEnvForms[itemID][groupID] = {};
    }

    return cachedInitialEnvForms[itemID][groupID][envID];
  }


  // Return jQuery element for the tab handle
  function getTabHandleForServiceItemId(id) {
    if (cuiMode) {
      return $('[data-mdb-toggle=tab][data-bs-target="#' + id + '"]').closest('.service-item-handle');
    }

    return $('[data-bs-toggle=tab][data-bs-target="#' + id + '"]').closest('.service-item-handle');
  }

  /**
    * Enable event handlers and dynamic behaviors that need to happen when the
    * page initially loads, or when the group changes.
    */
  function applyFormsetBehaviors() {
    var groupID = groupSelectize.getValue();

    $('select[name$="-environment"]').each(function () {
      var $envSelect = $(this);
      var envSelectize = c2.selectize($envSelect, {
        onChange: function (value) {
          envChangeHandler($envSelect, groupID, value);
        }
      });

      // Match form classes so updateFormState can do its thing
      $envSelect.addClass('form-control');

      if (cuiMode) {
        $envSelect.addClass('active');
      }

      // Initialize the active env so that the first calls to get cost/hostname preview
      // are not ignored.
      setActiveEnv(
        getItemIDFromSIDiv($envSelect.closest('.service-item')),
        groupID,
        envSelectize.getValue()
      );

      // Attempt to initialize the dropdown to the filterEnv, if it's defined
      // and exists in the dropdown. If neither, this "fails" silently.
      if (filterEnv) {
        // this triggers a change event
        envSelectize.setValue(filterEnv);
      }

      // If an env has a single choice, disable the select
      if (_.keys(envSelectize.options).length === 1) {
        envSelectize.disable();
      }
    });

    $('.service-item').each(function (index, item) {
      applySingleItemBehaviors($(item));
    });
  }


  /*
   * Given a SI div, return the numeric ID of the service item it represents.
   */
  function getItemIDFromSIDiv($item) {
    if ($item.hasClass('service-item')) {
      return $item.attr('id').split('item-')[1];
    }
  }


  /**
    * Apply behavior that needs to happen for each blueprint item when the
    * formset loads, or for a single blueprint item when its environment
    * changes.
    */
  function applySingleItemBehaviors($item) {
    // Wire the v5 date / date-time picker on this item's date fields. It fires a
    // native 'change', so cost recalc runs via the delegated handler above.
    if ($.bs5DateTimePicker) {
        $.bs5DateTimePicker.autoInit($item[0]);
    }
    initializePreconfigs($item);
    setupNetworkFieldBehavior($item);
    c2.dependentFields.init($item);

    // If an env is selected, calculate the rate
    if ($item.find('select[name$="-environment"]').val()) {
      if ($item.hasClass('pod') || $item.hasClass('provserver') || $item.hasClass('tfoperation')) {
        recalculateServiceItem($item.attr('id'));
      }
    }
    else if (!$item.hasClass('blueprint') && !$item.hasClass('provserver') && $item.attr('id') && $item.attr('id') != 'item-0') {
      // Calculate rate for non-server tiers except sub blueprint tiers
      recalculateServiceItem($item.attr('id'));
    }
  }


  /*
   * Given a group and the first PSSI in the subsequent order form, load all forms for that PSSI
   * for any configured environments it has. This will be used to show a cost comparison preview
   * for those environments.
   */
  function preloadPSSIFormsForConfiguredEnvs() {
    // Only do this for the first PSSI
    var $pssis = $('.service-item.provserver');
    if ($pssis.length !== 1) {
      // Only show cost comparisons for blueprints with one PSSI for now
      return;
    }
    var $item = $pssis.first();

    var envIDs = $item.data('configured-env-ids');
    if (envIDs === undefined) {
      // This PSSI has no environments configured for it
      return;
    }
    var itemID = $item.attr('id').split('item-')[1];
    var groupID = groupSelectize.getValue();
    var resourceName = resourceNameField.val();
    var pssiFormURL = _.template('<%= base %>?group_id=<%= groupID %>&service_item=<%= itemID %>&env_id=<%= envID %>');
    var envsToPreload = envIDs.slice(0, maxNumberOfEnvsToCompare);

    _.each(envsToPreload, function (envID) {

      $.get(pssiFormURL({ base: formSetBaseURL, itemID: itemID, groupID: groupID, envID: envID }) + getRecipientQueryParam(), function (response) {
        if (response.error) {
          logger.error(response.error);
        } else {
          cacheInitialEnvForm(itemID, groupID, envID, response.content);

          if (showCostPreview) {
            // Create a jQuery object with form's content so it can be serialized for cost calculation
            var $tempForm = $('<div style="display:none"></div>');
            $tempForm.html(response.content);
            var serializedForm = getSerializedPSSIForm($tempForm);
            $tempForm.remove();

            getPSSIInitialCost(itemID, groupID, envID, resourceName, serializedForm);
          }
        }
      });

    });
  }

  /*
   * Serialize all fields in a PSSI form except those that are not intended for posting (e.g.
   * metadata used to build dynamic NIC fields).
   */
  function getSerializedPSSIForm($item) {
    return $item.find('input:not([name$="_metadata"]), select, textarea').serialize();
  }


  /*
   * Add rate for env to the comparison chart.
   */
  function addToCostComparison(itemID, envID, totalCost, currencyUnit, timeUnit) {
    var $comp = $('#env-cost-comp');
    var $item = $('#item-' + itemID);
    var $env = $item.find('select[name$="-environment"]');
    if ($env.length === 0) {
      return;
    }
    var envName = $env[0].selectize.options[envID].text;

    if ($comp.length === 0) {
      $comp = createCostCompChart(currencyUnit, timeUnit);
    }

    addToCostCompChart($comp, envName, totalCost);
  }


  function createCostCompChart(currencyUnit, timeUnit) {
    var compiled = _.template(
      '  <div class="row mb-3">' +
      '    <label class="col-lg-3 form-label">' +
      '      ' + gettext("Cost Preview") + ' (<%= currencyUnit %>/<%= timeUnit %>)' +
      '      <div class="infotip" data-bs-toggle="tooltip" data-bs-html="true"' +
      '        data-bs-title="<p>' + gettext("Costs by environment.") + '</p>' +
      '   <p>' + gettext("This comparison of base costs will <em>not</em> update as you make changes below.") + '<p>"' +
      '        ></div>' +
      '    </label>' +
      '    <div class="<%= colSetting %>">' +
      '      <div id="env-cost-comp"></div>' +
      '    </div>'
    );
    var $costPreview = compiled({ currencyUnit: currencyUnit, timeUnit: timeUnit, colSetting: cuiMode ? 'col-lg-12' : 'col-lg-9' });
    var $costPreviewWrap = $('<div id="cost-preview-wrap"></div>');
    $costPreviewWrap.append($costPreview);
    $('#order-form-wrap').append($costPreviewWrap);
    var $comp = $('#env-cost-comp');
    drawCostCompChart($comp, currencyUnit, timeUnit);
    return $comp;
  }


  /*
   * Draw an empty cost preview chart in $comp, for addToCostCompChart to fill.
   */
  function drawCostCompChart($comp, currencyUnit, timeUnit) {
    $comp
      .css({
        'border': '1px solid var(--bs-border-color)'
      })
      .highcharts({
        title: { text: '' },
        subtitle: { text: '' },
        xAxis: { // Vertical axis
          // prevent tick marks from being drawn
          tickColor: 'transparent',
          // This means xAxis labels come from the series data
          type: 'category'
        },
        series: [{
          color: '#99bc82',
          data: []
        }],
        yAxis: { // Horizontal axis
          // don't round chart up to nearest tick, just end the bar at 100% width
          endOnTick: false,
          labels: { formatter: intsForLargeValues },
          title: { text: '' }
        },
        legend: { enabled: false },
        chart: { type: 'bar' },
        tooltip: {
          // remove the empty category name from tooltip header; otherwise it breaks layout
          headerFormat: '',
          pointFormatter: function () {
            return (
              gettext("Base cost for this environment per") + ' ' + timeUnit + ': <b>' +
              rate_with_units(this.y, currencyUnit) +
              '</b>');
          }
        },
        exporting: { enabled: false },
        credits: { enabled: false }
      });
  }


  /*
   * Given a chart series object with name and data, add it to the comparison chart.
   */
  function addToCostCompChart($comp, envName, totalCost) {
    var chart = $comp.highcharts();
    var barHeightPx = 12;
    var minChartHeightPx = 80;

    chart.series[0].addPoint([envName, totalCost], false);

    // Update the chart height
    $comp.css('height', minChartHeightPx + (chart.series[0].data.length * barHeightPx));
    chart.reflow();

    // Fade in, see catalog.less
    $('#cost-preview-wrap').addClass('show');
  }

  function reload_mdbootstrap_js(src) {
    $('script[src="' + src + '"]').remove();
    $('<script>').attr('src', src).attr('type', "text/javascript").prependTo('body');
  }
  // Apply behavior that needs to happen once after a form load, for any form
  function applyPostLoadBehaviors() {
    // In the case of script items, syntax highlight the code
    hljs.initHighlighting();

    c2.sliders.init();
    updateFormState();

    // Tune layout based on the formset for the chosen group
    tuneLayoutForFormset();

    //Load MDBootstrap JS for CUI
    if (cuiMode) {
      reload_mdbootstrap_js(staticFileUrlPrefix + 'mdbootstrap/js/mdb.min.js')
    }
  }
  /*
   * For each preconfig on the blueprint item, select the first choice if none
   * is selected; for a yet-unknown reason the Django form field's `initial`
   * value isn't honored.
   */
  function initializePreconfigs($item) {
    var $choices;
    var $radioGroups = $item.find('#blueprint-order-form input[type=radio]').closest('.controls');
    $radioGroups.each(function () {
      $choices = $(this).find('input[type=radio]');

      if ($choices.filter(':checked').length === 0) {
        $choices.filter(':first').prop('checked', true);
      }
    });
  }


  function serviceItemRequiresAttention(id, doesRequire) {
    var $handle = getTabHandleForServiceItemId(id);

    if (doesRequire) {
      $handle.find('.state-error').show();
      $handle.find('.state-ready').hide();
    } else {
      $handle.find('.state-error').hide();
      $handle.find('.state-ready').show();
    }
  }


  /**
   * Enable or disable the submit button based on the state of the formset.
   * Also handles setting the check mark and x indicators for which tabs require
   * attention, as well as hiding elements or making them active as appropriate.
   *
   * Should be called by every keyup/change handler that may affect form state.
   */
  function updateFormState() {
    let formsetHasErrors = false;
    let visibleItemCount = 0;
    let invisibleItemCount = 0;
    let willShowPane;

    if ($('#id_recipients').length) {
      let $field = $('#id_recipients');
      let invalidTokens = getInvalidTokens($field);
      if (invalidTokens.length > 0) {
        logger.debug(invalidTokens);
        formsetHasErrors = true;
      }
    }

    $('.service-item').each(function () {
      let $pane = $(this);
      let id = $pane.attr('id');
      let $handle = getTabHandleForServiceItemId(id);
      // Show this build item if it should always show or if it has inputs the
      // user can interact with.
      let alwaysShowOnOrderForm = $pane.data('show');
      willShowPane = alwaysShowOnOrderForm || doesPaneHaveInputs($pane);
      if (willShowPane) {
        if ($('.nav-link.active[data-bs-toggle="tab"]').length === 0) {
          // Only manually set active items if there isn't already one
          if (visibleItemCount === 0) {
            // Select the first visible tab handle and pane to be active, so the pane is displayed
            $handle.find('.nav-link[data-bs-toggle="tab"]').addClass('active');
            $pane.addClass('active show');
          }
        }
        visibleItemCount += 1;
      } else {
        // Mark as hidden rather than removing because it needs to be POSTed
        $handle.addClass(hiddenClassName);
        $pane.addClass(hiddenClassName);
        invisibleItemCount += 1;
      }

      if (doesPaneHaveErrors($pane)) {
        formsetHasErrors = true;
        serviceItemRequiresAttention(id, true);
      } else {
        serviceItemRequiresAttention(id, false);
      }

    });

    if (visibleItemCount === 0) {
      // no SIs are visible, so hide the navigation column and the tab-content for SIs
      $('#service-item-nav').addClass(hiddenClassName);
      $('#service-items .tab-content').addClass(hiddenClassName);
    } else if (visibleItemCount === 1) {
      // only one SI is visible, so hide the navigation column and make the tab-content full-width
      $('#service-item-nav').addClass(hiddenClassName);
      $('#service-items .tab-content').removeClass('col-sm-9');
    }
    if (invisibleItemCount !== 0) {
      // only show this message if the user can manage the blueprint
      if ($('.blueprint-overview').find('.bi.bi-gear-fill').length) {
        console.log("One or more blueprint items were hidden because they do not require user input");
        console.log("You are seeing this message because you can manage this blueprint.");
      }
    }

    updateSubmitButton(formsetHasErrors);
  }

  function updateSubmitButton(hasErrors) {
    $('#submit-btn').prop('disabled', hasErrors ? 'disabled' : '');
  }


  /**
   * Return true if this service item pane contains any validation errors.
   */
  function doesPaneHaveErrors($pane) {
    var className = '.form-group';
    if (cuiMode) {
      className = '.input-group';
    }
    var hasAnError = $pane.find(className + '.has-error').length > 0;

    if (!hasAnError) {
      // Blank required fields including Environment dropdowns
      $pane.find('label.requiredField').each(function () {
        var $label = $(this);

        $label.closest(className).each(function () {
          var $formGroup = $(this);
          if ($formGroup.data('dependent-field-visible') === false) {
            // If this field is marked hidden, it's a dependent field and should be ignored.
            // These are faded in and out so we cannot use :visible to determine their state here.
            logger.debug('    Ignoring required field. It is hidden by a controlling field.');
            return;
          }

          var $field = getFormFieldFromGroup($formGroup);
          if ($field.length && !$field.val()) {
            logger.debug('    Field is required but empty', $field);
            hasAnError = true;
          }
        });
      });
    }

    return hasAnError;
  }


  /*
   * Returns true if there are any fields that the user can impact. When a build
   * item's show_on_order_form is false, this is what determines whether the
   * build item is displayed.
   */
  function doesPaneHaveInputs($pane) {
    // :input includes all form input types, not just text boxes
    var inputs = $pane.find(':input')
      // Disabled fields like Hostname Preview or Environment (when there's
      // only one option) don't count.
      .not(':disabled')
      // Selectize dropdowns create an input and "hide" it by placing it off to
      // the left of the screen. Don't count these.
      .not('[style*="left: -10000px"]')
      // Don't count hidden inputs that the user can't interact with, such as
      // the group/service_item/os_build fields, fakePasswordTrick fields, and
      // invisible dependent fields. Provided/predefined parameters don't appear
      // in the form HTML at all, but they would also be excluded by this if we
      // changed them to be hidden fields in the future.
      .not('.' + hiddenClassName)
      .not('[type=hidden]')
      .not('[style*="display: none"]');
    // if there are inputs, then skip the check for selectize inputs
    if (inputs.length > 0) {
      return true;
    }
    // if any unlocked, enabled selectize-inputs, then this pane has inputs a user can use
    var selectizeInputs = $pane.find('.selectize-input')
      .not('.disabled').not('.locked');
    return selectizeInputs.length > 0;
  }


  /*
   * Given a .form-group container, return the .form-control that
   * will behave consistently (e.g. provides .val() method) and is not
   * a selectize-dropdown or selectize-control.
   */
  function getFormFieldFromGroup($formGroup) {
    var className = '.form-group';
    if (cuiMode) {
      className = '.input-group';
    }
    return $formGroup.closest(className)
      .find('.form-control')
      .not('.selectize-control,.selectize-dropdown');
  }


  /*
   * Given a form field that may have changed, update its service item form and if it's a PSSI
   * recalculate its rate. This triggers an AJAX request, so should be debounced e.g. to fire at
   * most once every 500ms or so.
   */
  function updateFormIfFieldChanged(e) {
    logger.debug('updateFormIfFieldChanged', '  e.type: ', e.type);
    if (!eventImpactsValidationOrRateCalculation(e)) {
      return;
    }
    /*jshint validthis: true */
    var $field = $(this);
    var className = '.form-group';
    if (cuiMode) {
      className = '.input-group';
    }
    var $myGroup = $field.closest(className);
    if ($myGroup.hasClass('environment-option')) {
      // Environment changes are handled elsewhere
      return;
    }

    if ($field.hasClass('selectize-control')) {
      // If a selectize is changed, depending on how, `this` may be the selectize-control. We want
      // the original select so we can do .val() etc.
      logger.debug('  $field has .selectize-control, getting actual select');
      $field = getFormFieldFromGroup($myGroup);
      logger.debug('  New $field: ', $field);
    }

    logger.debug('  $field: ', $field);
    logger.debug('    val:', $field.val());

    var wasInvalid = $myGroup.hasClass('has-error');
    var isValid = validateField($field);

    // Fields that had server-side validation errors are cleared as soon as client-side validation
    // passes so the form can be resubmitted.
    if (wasInvalid && isValid) {
      $field.removeClass('has-error');
      $myGroup.removeClass('has-error');
    }

    var $item = $field.closest('.service-item');
    removeHostnamePreviewErrors($item);

    if (isValid && $item.attr('id') != 'item-0') {
      // Fetch new rates and validation from server
      recalculateServiceItemDebounced($item.attr('id'));
    }

    if (cuiMode) {
      if ($field.hasClass('render_as_datepicker')) {
        if (!$field.hasClass('active')) {
          $field.addClass('active')
        }
      }
    }

    updateFormState();
  }


  /*
   * Return true if this event's key code or target should trigger validation on a field or
   * trigger the recalculateServiceItem call.
   */
  function eventImpactsValidationOrRateCalculation(e) {
    if (e.type == 'change') {
      return true;
    }

    var key = e.key || e.keyCode;

    // Include numeric codes to support older browsers
    var ignoreKeyCodes = [
      // Tabbing to the next/prev field already triggers a change event so don't handle keyup here.
      'Tab', 9,
      'Shift', 16,
      'Enter', 13,
      'Alt', 18,
      'Meta', 91,
      'Escape', 27,
      'ArrowUp', 38,
      'ArrowDown', 40,
      'ArrowLeft', 37,
      'ArrowRight', 39,
    ];

    if (ignoreKeyCodes.indexOf(key) !== -1) {
      return false;
    }
    if (e.target.parentNode.className.indexOf('selectize') != -1) {
      logger.debug('  keyup on selectize; ignore.');
      return false;
    }

    logger.debug('  key:', key, 'code:', e.keyCode);
    return true;
  }


  var delay = (function () {
    var timer = 0;
    return function (callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  })();


  /*
   * Since the user can't change the hostname preview directly, remove any hostname preview errors
   * when any other field changes.
   */
  function removeHostnamePreviewErrors($item) {
    var className = '.form-group';
    if (cuiMode) {
      className = '.input-group';
    }
    $item.find('input[name$="-hostname"]:disabled').closest(className).removeClass('has-error');
  }



  /*
   * Prepares POST data for a single-SI request (which service_item_formset view interprets as a
   * "get rate" request) and calls `callback` function with response.
   *
   * Returns immediately if the formset index and prefix cannot be determined.
   */
  function getTierCost(itemID, groupID, envID, resourceName, serializedForm, callback) {
    var params = getFormPrefixAndIndex(itemID);
    if (params === undefined) {
      // SIs with errors don't need rate calc
      return;
    }

    _.assign(params,c2.forms.makeFormsetManagementData(1));
    var data = $.param(params) + '&';
    data += serializedForm;

    // Add env ID to the post data using the correct name for a formset form
    // following the examples from the lodash documentation: https://lodash.com/docs/4.17.15#template
    if (envID) {
      var compiled = _.template('&<%= prefix %><%= index %>-environment=<%= envID %>');
      data += compiled({ 'prefix': params.pssi_form_prefix, 'index': params.pssi_form_index, 'envID': envID });
    }
    if (resourceName) {
      var compiled = _.template('&<%= prefix %><%= index %>-resourceName=<%= resourceName %>');
      data += compiled({ 'prefix': params.pssi_form_prefix, 'index': params.pssi_form_index, 'resourceName': resourceName });
    }

    $.post(siCostURL + '?group_id=' + groupID + getRecipientQueryParam(), data, callback);
  }


  /*
   * Get the cost for this PSSI form and add it to the cost preview chart.
   */
  function getPSSIInitialCost(itemID, groupID, envID, resourceName, serializedForm) {
    serializedForm = resequencePSSIFieldNames(itemID, serializedForm);
    getTierCost(itemID, groupID, envID, resourceName, serializedForm, function (response) {
      if (response.rateBreakdown === undefined) {
        logger.error('response has no rateBreakdown: ', response);
      } else {
        logger.info(response);
        addToCostComparison(
          itemID,
          envID,
          response.rateTotal,
          response.rateCurrencyUnit,
          response.rateTimeUnit
        );
      }
    });
  }


  /*
   * Similar to resequenceForms, which works in the DOM, this corrects the Django formset form
   * index on all parameters in the serializedForm string.
   *
   * E.g. "form-0-group=4&form-0-service_item=250&..."
   *  --> "form-1-group=4&form-1-service_item=250&..."
   */
  function resequencePSSIFieldNames(itemID, serializedForm) {
    var formsetIndex = $('.service-item').index($('#item-' + itemID));
    var re = /form-[0-9]+-/g;
    var newstr = 'form-' + formsetIndex + '-';
    return serializedForm.replace(re, newstr);
  }


  // Serialize all form fields in this SI row and send to server
  function recalculateServiceItem(itemDivID) {
    var $item = $('#' + itemDivID);
    var itemID = itemDivID.split('item-')[1];  // Either like '3' or '3-2'
    var serializedForm = getSerializedPSSIForm($item);
    var groupID = groupSelectize.getValue();
    var resourceName = resourceNameField.val();
    // If a PSSI environment dropdown is disabled (has only one choice), it won't be posted so we
    // need to add its value manually.
    var envID = getSelectedEnvID($item);
    var chart = $item.find('.si-rate');
    // Use the small inline spinner rather than showSpinner's block spinner: the latter's
    // logo-image markup is taller than this one-line Rate row and overflows past it toward
    // whatever sits below (e.g. the Submit/Cancel buttons), appearing to render at the bottom
    // of the page instead of over the Rate row.
    if (chart) c2.spinners.showInlineSpinner({element: chart});
    // No need to hide spinner later, because the chart will be replaced with new content, or the error message

    getTierCost(itemID, groupID, envID, resourceName, serializedForm, function (response) {
      var activeEnvID = getActiveEnv(itemID, groupID);
      if (envID != activeEnvID) {
        var compiled = _.template(
          'Cost request finished for item <%= itemID %>, group <%= groupID %>, and env <%= envID %>. ' +
          'Ignoring because a different env (<%= activeEnvID %>) is now active.');
        var msg = compiled({
          itemID: itemID, groupID: groupID, envID: envID, activeEnvID: activeEnvID
        });
        logger.debug(msg);
        return;
      }

      if (response.error !== undefined) {
        var basePath = new URL(document.baseURI).pathname;
        var url = basePath + 'exception/'
        var msg = $('<div class="alert alert-danger"></div>')
        var link = $('<a href="' + url + '">Click here</a>');
        if (response.traceback) {
            link.on('click', function () {
                var fullErrorMsg = response.error + response.traceback;
                localStorage.setItem('errorMessage', fullErrorMsg);
            });
        } else {
            link.on('click', function () {
                localStorage.setItem('errorMessage', response.error);
            });
        }
        msg.append('Error occured: ').append(link).append(' to see detailed error');
        chart.html(msg)
      }
      if (response.rateBreakdown !== undefined) {
        drawRateChart(
          response.rateBreakdown,
          response.rateTotal,
          response.rateCurrencyUnit,
          response.rateTimeUnit,
          chart);
        // If hostname field is disabled, we know it's a hostname preview
        // Update to the new value, and remove the error class if it exists
        var $preview = $item.find('input[name$="-hostname"]:disabled');
        $preview.val(response.hostnamePreview);
      } else {
        serviceItemRequiresAttention(itemID, true);
        logger.error('response.content: ', response.content);
        //$item.replaceWith(response.content);
      }
    });
  }
  // Debounced version waits at least 1s between each rate calculation
  // Used when any field in a single service item changes
  var recalculateServiceItemDebounced = _.debounce(recalculateServiceItem, 1000);

  /*
   * Return object with this PSSI's formset index and form prefix, used by the view that returns
   * PSSI form cost and validation info.
   */
  function getFormPrefixAndIndex(itemID) {
    var prefix = getTierFormPrefix(itemID);
    var index = getTierFormIndex(itemID, prefix);
    if (index === undefined) {
      // PSSI has no field to derive the form index from
      return undefined;
    }
    return {
      // rename this tier_form_*
      'pssi_form_prefix': prefix,
      'pssi_form_index': index
    };
  }

  /*
   * Return the prefix string for this PSSI's form. Django formsets produce form fields
   * with names like 'form-1-mem_size', where the prefix would be 'form-'.
   * itemID is something like '3' or '3-2'
   */
  function getTierFormPrefix(itemID) {
    var prefix = "form-";
    var idParts = itemID.split('-');
    if (idParts.length > 1) {
      // this is a sub-bp service item
      prefix = "bpsi" + idParts[0] + "-";
    }
    return prefix;
  }


  /*
   * Return the integer form index for this SI's form. Django formsets produce form fields
   * with names like 'form-1-mem_size', where the index would be 1.
   *
   * This is simply derived from the group dropdown which all orders have.
   */
  function getTierFormIndex(itemID, prefix) {
    var $group = $('#item-' + itemID).find('input[name$="-group"]');
    if ($group.length === 0) {
      return;
    }
    return $group.attr('name').split(prefix)[1].split('-')[0];
  }

  /*
   * Return the environment ID of the selected environment (of the disabled dropdown in the case
   * where there is only one choice).
   */
  function getSelectedEnvID($item) {
    var $env = $item.find('select[name$="-environment"]');
    var envID = $env.val();
    if ($env.length && $env.prop('disabled')) {
      $env[0].selectize.enable();
      envID = $env.val();
      $env[0].selectize.disable();
    }
    return envID;
  }

  function rate_with_units(rate, currencyUnit, timeUnit) {
    // Use at least 2 decimal places, or more if we have them.
    // Useful for short time scales like $/hr that may have sub-cent precision.
    var decimalPlaces = (rate.toString().split('.')[1] || "").length;
    decimalPlaces = Math.max(decimalPlaces, 2);
    var rateString = currencyUnit + rate.toFixed(decimalPlaces);
    if (timeUnit !== undefined) {
      rateString += '/' + timeUnit;
    }
    return rateString;
  }

  /*
   * Flatten nested rate dict into list of highcharts series, or a single value into a series list.
   */
  function convertToSeries(key, value) {
    // Assign colors to the default rate types. Non-default rate types will
    // randomly be assigned colors.
    var colorForResourceType = {
      'Extra': '#c26e0e',
      'OS Build': '#ffd845',
      'Applications': '#ffb313',
      'Mem Size': '#8fbcf2',
      'Disk Size': '#4a9de4',
      'CPUs': '#335b83'
    };

    if (_.isObject(value)) {
      // value is a dict, possibly nested
      var dict = value;
      // call this function recursively on each key-value pair, and concat
      // them into a single list using reduce
      return _.reduce(
        dict,
        function (memo, childValue, childKey) {
          // using push.apply here as equivalent of Python's .extend
          // http://stackoverflow.com/a/1374131
          memo.push.apply(memo, convertToSeries(childKey, childValue));
          return memo;
        },
        []  // initial memo for reduce
      );
    } else {
      // value is a rate, convert it to a series
      var rate = value;
      if (rate) {
        return [{
          name: key,
          data: [rate],
          color: colorForResourceType[key] || null
        }];
      }
    }
  }

  /*
   * Formatter for Highcharts axis labels. Adjust label precision: as values get large cast to int.
   */
  function intsForLargeValues() {
    /*jshint validthis: true */
    return (this.value > 99.99) ? parseInt(this.value) : this.value;
  }


  /*
   * width: optional chart width, by default sized to the standard order form.
   */
  function drawRateChart(rateBreakdown, rateTotal, currencyUnit, timeUnit, $chart, width) {
    var series = convertToSeries('', rateBreakdown);
    if (series.length === 0) {
      // Either rates have not been configured for this order, or the user has
      // not filled out the form yet. Currently it's not easy to know whether
      // to show the cost breakdown chart. So don't show it until there is
      // at least one series with data. Eventually, if it becomes possible to
      // know that rates apply for this env/user, we could show a card header
      // saying "Fill out this form to see a cost breakdown chart".
      //console.log("No rate breakdown data; hiding cost breakdown chart.");
      $chart.html('Not available.')
      return;
    }

    // Highcharts stacked bar chart shows data from right to left, so reverse
    // the order of the series.
    series = series.reverse();

    $chart
      .css({
        // This width is carefully chosen to align the chart with the form fields above it
        width: width || '630px',
        // includes buffer space in case legend becomes 2 lines
        height: '160px',
        margin: '0 auto'
      })
      .show()
      .highcharts({
        title: {
          text: rate_with_units(rateTotal, currencyUnit, timeUnit) + gettext(' total')
        },
        subtitle: { text: '' },
        series: series,
        xAxis: { visible: false },
        yAxis: {
          // autoRotation: false,  // This is not always honored. Rotated labels break the chart.
          labels: { formatter: intsForLargeValues },
          // don't round chart up to nearest tick, just end the bar at 100% width
          endOnTick: false,
          min: 0,
          title: { text: '' }
        },
        legend: {
          reversed: true
        },
        chart: {
          type: 'bar'
        },
        tooltip: {
          // remove the empty category name from tooltip header; otherwise it breaks layout
          headerFormat: '',
          pointFormatter: function () {
            /*jshint validthis: true */
            return this.series.name + ': <b>' + rate_with_units(this.y, currencyUnit) + '</b>';
          }
        },
        plotOptions: {
          series: {
            animation: false,
            stacking: 'normal'
          }
        },
        exporting: {
          enabled: false
        },
        credits: {
          enabled: false
        }
      });
  }


  /**
   * For each NIC select field, set up a change handler to hide/show the static
   * IP field as required.
   */
  function setupNetworkFieldBehavior($item) {
    var $nic;

    $item.find('select[name*=sc_nic_]').each(function () {
      $nic = $(this);

      // On change (do not bind more than once)
      $nic.off('change').on('change', function () {
        setupFieldsForNetwork($(this));
      });

      // Initial setup
      setupFieldsForNetwork($nic);
    });
  }


  /**
   * When a network is selected, hide or show the static IP field and
   * initialize it as needed.  Uses a hidden input field whose value contains
   * metadata about each network option.
   */
  function setupFieldsForNetwork($nic) {
    logger.debug('setupFieldsForNetwork() $nic: ', $nic);
    var selectedNetwork = $nic.val();
    var index = parseInt($nic.attr('name').split('sc_nic_')[1]);
    var $serviceItem = $nic.closest('.service-item');
    // There may be multiple _metadata fields for a NIC but they'll all have the same payload
    // so just use the first found.
    var $netInfo = $serviceItem.find('input[name*=sc_nic_' + index + '_metadata]').first();
    var netInfo, netInfos;

    var $help = $nic.next('.help-block');
    if ($help.length === 0) {
      // On first load, help text will be created.
      $help = $('<div class="help-block"></div>');
      $nic.after($help);
    }

    var $errorMsg = $help.find('strong');

    // There may be a 2nd IP field with the same name if there is a network
    // with 'user defined' schema; here we want the IP field of the form-group
    // associated with 'static-only' networks.
    var $staticOnlyIPField = $serviceItem.find('input[name*=sc_nic_' + index + '_ip]').first();
    var className = '.form-group';
    if (cuiMode) {
      className = '.input-group';
    }
    var $staticOnlyRow = $staticOnlyIPField.closest(className);
    positionChildField($nic, $staticOnlyRow, $staticOnlyIPField);

    // Create the 'user-defined' DHCP/static radio buttons and its static IP
    // field from scratch. Get the base name for these elements by removing
    // "_ip" from the static-only IP field's name (e.g. form-0-sc_nic_0_ip).
    // We use name instead of ID because the ID can contain the wrong form
    // index. ID does not get resequenced by resequenceForms, so it sometimes
    // contains "form-0" instead of the correct index.
    // TODO: resequence IDs to have the correct index
    var baseName = $staticOnlyIPField.attr('name').split('_ip')[0];
    var $choiceRow = $serviceItem.find('#id_' + baseName + '_choiceRow');
    if ($choiceRow.length === 0) {
      $choiceRow = createChoiceRow(baseName, $staticOnlyRow);
    }
    var $choiceIPField = $choiceRow.find('input[name*=sc_nic_' + index + '_ip]');

    $staticOnlyRow.hide();
    $choiceRow.hide();
    // Disable static IP fields so not posted
    $staticOnlyIPField.prop('disabled', true);
    $choiceIPField.prop('disabled', true);

    try {
      var netInfoStr = $netInfo.val();
      if (netInfoStr) {
        netInfos = JSON.parse(netInfoStr);
      }
      netInfo = netInfos[selectedNetwork];
    } catch (ex) {
      console.error("Error reading metadata: ", ex.message);
    } finally {
      logger.debug('  netInfo:', netInfo);

      // Always executes. If an exception occurred above, netInfo will be
      // undefined and the IP field hidden.
      if (netInfo) {
        if ($nic.attr('readonly') == 'readonly') {
          // A baked-in NIC that does not require IP address from user will be set to
          // readonly so it can be hidden here.
          $nic.closest(className).hide();
        }

        var msg = '';
        var ip = $staticOnlyIPField.val();
        switch (netInfo.ip_provider) {
          case 'ipam':
            msg = gettext("IP addresses will be assigned from an IPAM utility.");
            break;
          case 'pool':
            msg = gettext("IP addresses will be assigned from an IP pool.");
            break;
          case 'dhcp':
            break;
          case 'user_static':
            // Assign the static IP field's value to the selected network's `initial_ip`.
            // Only do this for an empty value or one that does not conform to the selected
            // network's IP range.
            if (ip === '' || ip.indexOf(netInfo.initial_ip) === -1) {
              $staticOnlyIPField.val(netInfo.initial_ip || '');
            }
            $staticOnlyIPField.prop('disabled', false);
            $staticOnlyRow.show();
            $staticOnlyIPField.focus();
            break;
          case 'user_static_or_dhcp':
            // Need to reference the static IP field created in the form, which is still around
            // but just hidden in this case, because it has access to the initial IP for an
            // existing order in the edit case
            if (ip === '' || ip.indexOf(netInfo.initial_ip) === -1) {
              $choiceIPField.val(netInfo.initial_ip || '');
            }

            // Enable/disable the static IP field depending on the radio input
            $staticOnlyIPField.prop('disabled', $choiceRow.find('input[type=radio]').val() === 'DHCP');

            $choiceRow.show();
            break;
        }

        if ($errorMsg.length !== 0) {
          // Replace the help text with the validation error message
          msg = $errorMsg.html();
        }

        $help.html(msg);
      }
    }
  }

  function createChoiceRow(baseName, $prevRow) {
    var baseID = 'id_' + baseName;
    var radioName = baseName + '_choice';
    var dhcpID = baseID + '_dhcp';
    var staticID = baseID + '_static';
    var $dhcpInput = $('<input>').attr({ type: 'radio', value: 'DHCP', name: radioName, id: dhcpID, checked: 'checked' });
    var $dhcpLabel = $('<label>').attr('for', dhcpID).addClass('form-label').text(gettext('Use DHCP'));
    var $staticInput = $('<input>').attr({ type: 'radio', value: 'static', name: radioName, id: staticID });
    var $staticLabel = $('<label>').attr('for', staticID).addClass('form-label').text(gettext('Static IP Address') + '  ');
    var $ipInput = $('<input>').addClass('form-control').attr({ name: baseName + '_ip', type: 'text' }).css({ width: 'auto', display: 'inline-block' });
    var $choiceRow = $('<div>').attr('id', baseID + '_choiceRow').addClass('mb-3 row form-group')
      .append(
        $('<div>').addClass('col-lg-3'),
        $('<div>').addClass('col-lg-9 controls')
          .append($('<div>').append($dhcpInput, $dhcpLabel), $staticInput, $staticLabel, $ipInput)
      );

    // Depending on radio selection, toggle disabled state of static IP field
    $choiceRow.find('input[type=radio]').on('change', function () {
      var $ip = $choiceRow.find('input[type="text"]');
      if ($(this).val() === 'DHCP') {
        $ip.prop('disabled', true);

        // Clear any former validation error state to allow form submission
        markFormGroupValid($choiceRow, true);
        removeValidationError($ip);
      } else {
        $ip.prop('disabled', false);
      }
    });
    $prevRow.after($choiceRow);
    return $choiceRow;
  }


  /**
   * Indent a field below another to visually group them, and align things nicely.
   * This is far simpler than using Django forms/widgets fu.
   */
  function positionChildField($parent, $childRow, $childField) {
    var $label = $childRow.find('label');
    if ($label.hasClass('child-field')) {
      // Already in position
      return;
    }

    // First ensure IP field's row is adjacent to its NIC dropdown's row
    var className = '.form-group';
    if (cuiMode) {
      className = '.input-group';
    }
    $childRow.insertAfter($parent.closest(className));

    $label.removeClass('col-lg-3')
      // Class used for alignment but also to indicate that the field is in position
      .addClass('child-field')
      // Create an empty column to take the label's place
      .before('<div class="col-lg-3"></div>');

    $label.insertBefore($childField);

    // Override 100% width of the input field
    $childField.css('width', 'auto');
  }


  /**
    * Handle change event on environment dropdown. Load the runtime form for
    * specified group and selected environment.
    */
  function envChangeHandler($envSelect, groupID, envID) {
    if (envID && envID != 'None') {
      var itemID = $envSelect.closest('.service-item').attr('id').split('item-')[1];
      setActiveEnv(itemID, groupID, envID);
      loadSingleItemForm(groupID, itemID, envID);
    }
  }


  /*
   * Record the environment just selected and whose PSSI form is being loaded so that any pending
   * rate/validation requests for some other environment can be ignored.
   *
   * Only one env can be pending/loading at a time for a group/item context.
   */
  function setActiveEnv(itemID, groupID, envID) {
    if (activeEnv[itemID] === undefined) {
      activeEnv[itemID] = {};
    }
    activeEnv[itemID][groupID] = envID;
  }


  /*
   * Return an env ID or undefined.
   */
  function getActiveEnv(itemID, groupID) {
    if (activeEnv[itemID] === undefined) {
      activeEnv[itemID] = {};
    }
    return activeEnv[itemID][groupID];
  }


  // If the most recent filter values from the catalog view apply to
  // this blueprint, preselect them.
  function applyRequestParams(availableGroupIDs) {
    var querystring = location.search.slice(1);
    if (querystring.length !== 0) {
      var params = c2.querystring.parse(querystring);
      filterGroup = params.group || undefined;

      // `filterEnv` is defined above, so its value will be available to the
      // formset-load function where we can auto-select any env dropdowns that
      // match filterEnv.
      filterEnv = params.env || undefined;
    }

    if (filterGroup && _.contains(availableGroupIDs, filterGroup)) {
      groupSelectize.setValue(filterGroup);
      return true;
    }
  }


  function enableAllEnvSelects($container) {
    // By default, all env selects are enabled
    $container = $container || 'body';
    $('select[name$="-environment"]').each(function () {
      $(this)[0].selectize.enable();
    });
  }


  /*
   * Given a .form-control field (input, select, etc), do some client-side validation on it.
   * Return true if valid, false otherwise;
   */
  function validateField($field) {
    var className = '.form-group';
    if (cuiMode) {
      className = '.input-group';
    }
    var $formGroup = $field.closest(className);

    if ($field.is('input[name*="sc_nic"]') && $field.is('[name$="_ip"]')) {
      return validateIP($field, $formGroup);
    }

    return validateRequiredField($field, $formGroup);
  }


  /*
   * Validate value of a static IP input field and mark its form-group valid/invalid.
   * Return true if valid, false if not.
   */
  function validateIP($ip, $formGroup) {
    // Basic regex checking for four . separated integer octets
    var isValid = $ip.val().match(/^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/) !== null;
    var $error;

    if (isValid) {
      removeValidationError($ip);
    } else {
      createOrUpdateValidationError($ip, gettext("Enter a valid IPv4 address."));
    }
    markFormGroupValid($formGroup, isValid);
    return isValid;
  }


  /*
   * If $field is required but blank, mark its form-group invalid and return false.
   * Makes an exception for required fields that are hidden because they are dependent fields.
   * Otherwise, return true.
   */
  function validateRequiredField($field, $formGroup) {
    logger.debug('validateRequiredField', $field, $formGroup);

    var isVisible = true;
    if ($formGroup.data('dependent-field-visible') === false) {
      logger.debug('    Ignoring required field. It is hidden by a controlling field.');
      isVisible = false;
    }

    var isRequired = $formGroup.find('label').hasClass('requiredField');
    var isValid = !isVisible || (isVisible && (!isRequired || (isRequired && $field.val() !== '')));
    if (isValid) {
      removeValidationError($field);
    } else {
      createOrUpdateValidationError($field, gettext("This field is required."));
    }
    markFormGroupValid($formGroup, isValid);
    return isValid;
  }


  /*
   * Given a static IP input field, mark it valid or invalid based on boolean `isValid` param.
   * Also mark its label and the form-group of the corresponding NIC (which is a separate
   * form-group from its own).
   */
  function markFormGroupValid($formGroup, isValid) {
    if (isValid) {
      $formGroup.removeClass('has-error');
    } else {
      $formGroup.addClass('has-error');
    }
  }


  /*
   * Show a validation error 'msg' next to $field.
   * Appends a span.validation-error to the field's help-block, creating help-block if necessary.
   */
  function createOrUpdateValidationError($field, msg) {
    var $help = $field.next('.help-block');
    if (cuiMode) {
      $help = $field.parent().next('.help-block');
    }
    if ($field[0].id == "id_resource_name") {
      $help = $('.help-block.permanent');
    }
    var adjustedField = $field
    if (cuiMode) {
      adjustedField = $field.parent()
    }
    if ($field[0].dataset.position == "first") {
      adjustedField = $field.next('input[type="password"]')
      $help = adjustedField.next('.help-block');
    }
    if ($help.length === 0) {
      if (cuiMode) {
        adjustedField.parent().append('<span class="help-block form-helper mt-2 text-danger"></span>');
      } else {
        adjustedField.after('<span class="help-block form-helper"></span>');
      }
    }

    var $msg = $help.find('.validation-error');
    if ($msg.length === 0) {
      $help.append('<span class="validation-error">' + msg + '</span>');
    }
  }


  /*
   * Remove any validation error messages for this field.
   * This includes the span.validation-error created client-side, as well as certain Django form
   * errors that may have come from server side, so they don't interfere with client-side
   * validation.
   */
  function removeValidationError($field) {
    if ($field[0].id == "id_resource_name") {
      var $help = $('.help-block.permanent');
      $help.find('.validation-error').remove();
    } else if ($field[0].dataset.position == "first") {
      var adjustedField = $field.next('input[type="password"]')
      var $help = adjustedField.next('.help-block');
    } else {
      var $help = $field.next('.help-block');
      if (cuiMode) {
        $help = $field.parent().parent()
      }
      $help.find('.validation-error').remove();
    }
    // Django error messages have no special class, so try matching by string value
    var help = $help.html();
    if (help == '<strong>' + gettext("This field is required.") + '</strong>') {
      $help.html('');
    } else if (help == '<strong>' + gettext("Enter a valid IPv4 address.") + '</strong>') {
      $help.html('');
    }
  }


  function handleOrderSubmit(e) {
    e.preventDefault();

    // disable the button to prevent duplicate order creation
    $("#submit-btn").attr("disabled", true);
    c2.spinners.showSpinner({fade:true})


    /*jshint validthis: true */
    var $form = $(this);
    var groupID = groupSelectize.getValue();
    var $items = $form.find('.service-item');

    // Env dropdowns may be disabled when there is only one choice; to
    // serialize them they need to be enabled.
    enableAllEnvSelects();

    // Serialize the main order form wrapping all SIs as well as the forms
    // for each SI parameters section.
    var data = $.param(c2.forms.makeFormsetManagementData($items.length)) + '&';
    data += $('form').serialize();

    var formData = new FormData($('form#blueprint-order-form')[0]);
    var mData = c2.forms.makeFormsetManagementData($items.length)
    $.each(mData, function (key, value) {
      formData.append(key, value);
    })

    // POST files
    $.ajax({
      url: formSetBaseURL + '?group_id='+ groupID + getRecipientQueryParam() + '&' + getUIModeQueryParam(),
      type: 'POST',
      data: formData,
      cache: false,
      contentType: false,
      enctype: 'multipart/form-data',
      processData: false,
      success:function(response){
        if (response.redirectURL) {
          window.location.href = response.redirectURL;
          // return now to leave the page in a blocked state
          return;
        } else if (response.error) {
          $('#service-items').html(response.error).addClass('error');
        } else {
          $('#service-items').html(response.content);
        }

        applyFormsetBehaviors();
        applyPostLoadBehaviors();
        showOrderFormValidationErrors();
        c2.spinners.hideSpinner({fade:true});
      }
  });
  }


  function disableOrderForm(msg) {
    $('#blueprint-order-form [type=submit]').prop('disabled', 'disabled');
    $('#action-msg').html(
      '<div class="alert alert-warning">' +
      (msg || 'There is a problem with this blueprint.') +
      '  Please ask an administrator for help.</div>'
    );
  }


  /**
  * Ensure fields for each service item row are named with that form's formset prefix.
  * The first item's fields will start with 'form-0-', the next 'form-1-', etc.
  *
  * Or in the case of a blueprint service item (aka nested blueprint), all of
  * its form fields should have prefixes like 'bpsiNN-0-' and 'bpsiNN-1-',
  * where NN is an integer matching that blueprint item's ID.
  */
  function resequenceForms() {
    var $item, $field, indexAndName, name, parts, bpsiID;

    // First loop over all SIs except BPSIs and assign new names to each form field that have
    // the correct index, starting at 0
    $('.service-item').not('.nested').each(function (index, item) {
      $(item).find('[name^="form-"]').each(function () {
        $field = $(this);
        // Remove 'form-' from the name, leaving something like '0-mem_size'
        indexAndName = $field.attr('name').slice(5);
        // name is the Django form field's name, like 'mem_size'
        name = indexAndName.split('-')[1];
        $field.attr('name', 'form-' + index + '-' + name);
      });
    });

    // Do same thing if there are any BPSIs, but each has index starting with 0.
    // Fields within a sub-blueprint have names like 'bpsi384-0-mem_size'.
    $('.service-item.blueprint').each(function (i, bpsi) {
      $(bpsi).find('.service-item').each(function (index, item) {
        $(item).find('[name^="bpsi"]').each(function () {
          $field = $(this);
          // Remove 'bpsi' from the name, leaving something like '384-0-mem_size'
          indexAndName = $field.attr('name').slice(4);
          // parts should be an array with 3 items
          parts = indexAndName.split('-');
          // name is the Django form field's name, like 'mem_size'
          bpsiID = parts[0];
          name = parts[2];
          // Construct the new name with the correct formset index
          $field.attr('name', 'bpsi' + bpsiID + '-' + index + '-' + name);
        });
      });
    });
  }


  /**
   * Set up the RuntimeInputWidget behavior:
   * Disable/enable the original widget based on the checkbox.
   */
  function setupRuntimeField(name) {
    var $runtime = $('#runtime-' + name);
    var $widget = $('#runtime-widget-' + name);
    var $orig = $widget.find('.runtime-orig');
    var $user = $widget.find('.runtime-user');
    var $selectized;

    function morphRuntimeWidget() {
      if ($('#runtime-toggle-' + name).prop('checked')) {
        // Enable the input
        $orig.find('input, textarea, select, checkbox').prop('disabled', '');
        $selectized = $orig.find('.selectized');
        if ($selectized.length) {
          $selectized[0].selectize.enable();
        }

        $orig.find('button').show(); // Power Schedule gives an edit button to open a modal
        $runtime.val('_default_');
      } else {
        // Disable the input
        $orig.find('input, textarea, select, checkbox').prop('disabled', 'disabled');
        $selectized = $orig.find('.selectized');
        if ($selectized.length) {
          $selectized[0].selectize.disable();
        }
        $orig.find('button').hide(); // Power Schedule gives an edit button to open a modal
        $runtime.val('_runtime_');
      }
    }

    var $toggle = $('#runtime-toggle-' + name);
    $toggle.on('change', morphRuntimeWidget);

    morphRuntimeWidget();
  }


  /*
   * Ensure Cost preview is aligned with other form fields based on whether this order form has
   * tabs or not.
   *
   * Adding a class via JS enables some CSS rules to reach elements outside/above our control here.
   */
  function tuneLayoutForFormset() {
    var sideNav = $('#service-item-nav');

    if (sideNav.length && !sideNav.hasClass(hiddenClassName)) {
      if (!cuiMode) {
        $('#content').addClass('compact-layout');
      }
    } else {
      // No tabs; thus there is only a single SI and layout can be narrower
      if (!cuiMode) {
        $('#content').addClass('compact-layout more-compact');
      }
      // Special case: remove custom server SI panel
      var $panel = $('.service-item .item-details');
      if ($panel.find('.card-body .row').hasClass('no-details')) {
        $panel.hide();
      }

      // SIs have no tab handles, so remove them from the upper form too
      $('.alignment-shim.col-sm-3').hide();
      $('.alignment-shim.col-sm-9').removeClass('col-sm-9');
    }
    // Force Label 'col-lg-3' class removal for CUI - unsure where it's originally getting set
    if (cuiMode) {
      $('.form-label.col-lg-3').removeClass('col-lg-3');
    }

    // Now show the form if it's still hidden (only hidden on first page load).
    $('#blueprint-order-form').removeClass(hiddenClassName);

    if (cuiMode) {
      // reloading to apply mdb formats on the initial form fields
      reload_mdbootstrap_js(staticFileUrlPrefix + 'mdbootstrap/js/mdb.min.js')
    }

    // Initialize tooltips
    c2.tooltips.init();
    // Initialize clipboard
    c2.clipboard.init()
  }


  c2[__module__] = {
    init: init,
    setupRuntimeField: setupRuntimeField,
    updateFormState: updateFormState,
    // Also used by custom forms (survey_class_initialization_plus.js)
    drawRateChart: drawRateChart,
    drawCostCompChart: drawCostCompChart,
    addToCostCompChart: addToCostCompChart
  };

})('orderForm', window.c2);
